import React from 'react';
import '../../../services/ConsoleHelper.js';
import BackgroundVideo from '../components/BackgroundVideo';
import LoginForm from '../components/LoginForm';

const LoginScreen = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-[1000]">
      <BackgroundVideo />
      
      <div className="absolute top-0 left-0 w-full h-full bg-black/50 flex justify-center items-center">
        <div className="w-full max-w-md px-4 animate-fadeIn">
          <LoginForm />
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;